import { useEffect, useMemo, useState } from "react";
import { Loader } from "@googlemaps/js-api-loader";
import { mapsApiKey, mapsRegion } from "../../config/clientConfig";

const GOOGLE_PLACES_LIBRARIES = ["places"];

export function useGooglePlacesLoader() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState(null);
  const loader = useMemo(() => {
    return new Loader({
      apiKey: mapsApiKey,
      version: "weekly",
      libraries: GOOGLE_PLACES_LIBRARIES,
      region: mapsRegion,
    });
  }, []);

  useEffect(() => {
    let isCancelled = false;

    loader
      .load()
      .then(async () => {
        if (typeof window.google?.maps?.importLibrary === "function") {
          await window.google.maps.importLibrary("places");
        }
      })
      .then(() => {
        if (!isCancelled) {
          setLoadError(null);
          setIsLoaded(true);
        }
      })
      .catch((error) => {
        if (!isCancelled) {
          setLoadError(error);
          setIsLoaded(false);
        }
      });

    return () => {
      isCancelled = true;
    };
  }, [loader]);

  return { isLoaded, loadError };
}
